import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Components/Home';
import Facilities from './Components/AdditionalPages/Facilities';
import Admission from './Components/AdditionalPages/Admission';
import Contact from './Components/AdditionalPages/Contact';
import Courses from './Components/AdditionalPages/Courses';
import About from './Components/AdditionalPages/About';
import Testimonial from './Components/AdditionalPages/Testimonial';
import Gallery from './Components/AdditionalPages/Gallery';
import Vision from './Components/AdditionalPages/Vision';
import Thoughts from './Components/AdditionalPages/Thoughts';
import Nav from './Components/Nav';
import Footer from './Components/Footer';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Nav/>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/facilities' element={<Facilities/>}/>
          <Route path='/admission' element={<Admission/>}/>
          <Route path='/contact' element={<Contact/>}/>
          <Route path='/courses' element={<Courses/>}/>
          <Route path='/about' element={<About/>}/>
          <Route path='/testimonial' element={<Testimonial/>}/>
          <Route path='/gallery' element={<Gallery/>}/>
          <Route path='/vision' element={<Vision/>}/>
          <Route path='/thoughts' element={<Thoughts/>}/>
        </Routes>
        <Footer/>
      </BrowserRouter>
    </div>
  );
}

export default App;
